import { render, staticRenderFns } from "./RecipientStatistics.vue?vue&type=template&id=ecb63976&"
import script from "./RecipientStatistics.vue?vue&type=script&lang=js&"
export * from "./RecipientStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports